import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const setNonPlayingHostAtom = atom(
  null,
  (get, set, payload: { roundId: string }) => {
    const booking = get(currentBookingAtom);
    if (!booking) return;

    const roundExists = booking.rounds.some(
      (round) => round.localId === payload.roundId
    );
    if (!roundExists) return;

    const updatedRounds = booking.rounds.map((round) => ({
      ...round,
      isNonPlayingHost:
        round.localId === payload.roundId && !round.isNonPlayingHost,
    }));

    set(currentBookingAtom, {
      ...booking,
      rounds: updatedRounds,
    });
  }
);
